import React from 'react';

const HomePage = () => (
    <>
    <h1 className="welcome-banner">Welcome!</h1>
    <p>
        Just a little blog site where I can share a bit more about who I am and what I'm working on.
    </p>
    <p>
        I'm looking forward to adding some fun content to this site as I learn more about React.
    </p>
    </> 
);

export default HomePage;